const state = {
    // 外层容器与v-loading绑定的值，控制每次进入各个页面时的转圈loading效果
    vLoading: false
};

const mutations = {
    SET_LOADING(state, boolean) {
      state.vLoading = boolean;

    }
  };

const actions = {
    
    setLoading({ commit }, boolean) {
       
      commit('SET_LOADING', boolean);
    }
  };

  export default {
    // 命名空间
    namespaced: true,
    state,
    mutations,
    actions
  };